// extracted by mini-css-extract-plugin
export default {"cls1":"Description-Value_cls1__ZZ1-j","cls2":"Description-Value_cls2__qWLwx Description-Value_cls1__ZZ1-j"};